var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00851 13.4913C2.35307 12.8359 1.83315 12.0577 1.47843 11.2013C1.1237 10.3449 0.941131 9.42698 0.941132 8.5C0.941132 7.57302 1.12371 6.65512 1.47843 5.7987C1.83315 4.94229 2.35307 4.16413 3.00852 3.50866C3.66396 2.85318 4.44208 2.33324 5.29845 1.9785C6.15483 1.62376 7.07269 1.44118 7.99962 1.44118C8.92656 1.44118 9.84441 1.62376 10.7008 1.9785C11.5572 2.33324 12.3353 2.85319 12.9907 3.50866L3.00851 13.4913Z",
    fill: "#7BE89A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.235291 8.5C0.235291 4.21776 3.71759 0.735294 7.99963 0.735294C12.2817 0.735294 15.764 4.21776 15.764 8.5C15.764 12.7822 12.2817 16.2647 7.99963 16.2647C3.71759 16.2647 0.235291 12.7822 0.235291 8.5ZM7.99963 2.14706C4.49725 2.14706 1.64699 4.99746 1.64699 8.5C1.64699 12.0025 4.49725 14.8529 7.99963 14.8529C11.502 14.8529 14.3523 12.0025 14.3523 8.5C14.3523 4.99746 11.502 2.14706 7.99963 2.14706Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4505 6.11851C11.7261 6.39418 11.7261 6.84112 11.4505 7.11678L7.60037 10.967C7.32471 11.2427 6.8778 11.2427 6.60214 10.967L4.67712 9.04193C4.40147 8.76627 4.40147 8.31933 4.67712 8.04367C4.95277 7.768 5.39969 7.768 5.67534 8.04367L7.10125 9.46965L10.4522 6.11851C10.7279 5.84285 11.1748 5.84285 11.4505 6.11851Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.7a211f5b3622442691127d7283922990.svg";
export { ForwardRef as ReactComponent };